import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { slot: "footer" }
const _hoisted_6 = ["disabled"]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import Banner from '@components/Banner/Banner.vue';
import { useDeleteConfiguration, useUnbindConfiguration } from '../../queries/useConfigurationMutations';
import { ConfigurationResponse } from '../../models/configuration/ui-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigurationDeleteModal',
  setup(__props, { expose: __expose }) {

const store = useStore() as any;
const t = store.getters['i18n/t'];

const showModal = ref(false);
const configToDelete = ref<ConfigurationResponse | null>(null);

const boundApps = computed(() => configToDelete.value?.configuration?.boundApps || []);

const {mutate: deleteConfiguration, isPending: isDeletingConfiguration, isError: deleteConfigurationError, error: deleteConfigurationErrorData} = useDeleteConfiguration(store, handleSuccess);
const {mutateAsync: unbindConfiguration, isPending: isUnbindingConfiguration, isError: unbindConfigurationError, error: unbindConfigurationErrorData} = useUnbindConfiguration(store);

function openDelete(row: ConfigurationResponse) {
  configToDelete.value = row;
  showModal.value = true;
}

function closeDelete() {
  showModal.value = false;
  configToDelete.value = null;
}

async function onSubmitDelete() {
  if (!configToDelete.value) {
        return;
    }
    if (configToDelete.value.configuration.boundApps?.length) {
        Promise.all([...configToDelete.value.configuration.boundApps.map(appName => unbindConfiguration({ namespace: configToDelete.value!.meta.namespace, appName: appName, configName: configToDelete.value!.meta.name }))])
            .then(() => {
                deleteConfiguration({ namespace: configToDelete.value!.meta.namespace, configurationName: configToDelete.value!.meta.name });
            })
            .catch((error) => {
                store.dispatch('growl/error', {
                    title: t('epinio.services.errors.unbind.error.title'),
                    message: error?.message || t('epinio.services.errors.unbind.error.message'),
                });
            });
    } else {
        deleteConfiguration({ namespace: configToDelete.value.meta.namespace, configurationName: configToDelete.value.meta.name });
    }
}

function handleSuccess() {
  store.dispatch('growl/success', {
    title:   t('epinio.growl.configuration.delete.success.title'),
    message: t('epinio.growl.configuration.delete.success.message', { name: configToDelete.value?.meta.name }),
  });
  closeDelete();
}

__expose({ openDelete });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("You are attempting to delete the configuration ", -1)),
        _createElementVNode("strong", null, _toDisplayString(configToDelete.value?.meta?.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (boundApps.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Caution: "),
              _createTextVNode("The following applications are bound to this configuration. Proceeding will unbind them prior to deletion.")
            ], -1)),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boundApps.value, (app) => {
                return (_openBlock(), _createElementBlock("li", { key: app }, _toDisplayString(app), 1))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "\n        No applications are bound to this configuration.\n      ")),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_unref(unbindConfigurationError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 2,
            color: "error",
            label: _unref(unbindConfigurationErrorData)?.message || _unref(t)('epinio.configurations.errors.unbind')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_unref(deleteConfigurationError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 3,
            color: "error",
            label: _unref(deleteConfigurationErrorData)?.message || _unref(t)('epinio.configurations.errors.delete')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _cache[8] || (_cache[8] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "\n        Cancel\n      ", 32),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        variant: "destructive",
        disabled: _unref(isDeletingConfiguration) || _unref(isUnbindingConfiguration),
        onButtonClick: onSubmitDelete
      }, _toDisplayString(_unref(isDeletingConfiguration) || _unref(isUnbindingConfiguration) ? _unref(t)('generic.deleting') : _unref(t)('generic.delete')), 41, _hoisted_6)
    ])
  ], 40, _hoisted_1))
}
}

})